<i18n lang="yaml">
en:
  text: 'How to&nbsp;launch a&nbsp;corporate gateway visited by&nbsp;over 500 employees every day?'
  button: 'Read the full story'
ru:
  text: 'Как запустить корпоративный портал, который ежедневно будут посещать больше 500&nbsp;сотрудников.'
  button: 'Читать историю'
</i18n>

<template>
  <div class="story-widget">
    <img
      v-lazy-load
      class="story-widget__logo"
      :data-src="require('~/assets/images/header/success-story__zoon.svg?inline').default"
      alt=""
    >
    <div class="story-widget__inner">
      <div
        class="story-widget__description"
        v-html="$t('text')"
      >
      </div>
      <nuxt-link
        class="story-widget__link btn btn--xs btn--outline"
        :to="{
          path: '/success-story/zoon/',
          hash: ''
        }"
        @click.native="$emit('closeMenu')"
        v-html="$t('button')"
      ></nuxt-link>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'SuccessStoryWidget'
    }
</script>

<style lang="scss">
  .story-widget {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .story-widget__logo {
    max-width: 100%;
    max-height: 28px;
    margin: 18px 0 32px;
  }

  .story-widget__inner {
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .story-widget__description {
    @include text--sm;

    max-width: 292px;
    margin-bottom: 24px;
  }

  .story-widget__link {
    margin-top: auto;
    margin-bottom: 8px;
  }
</style>